/* eslint-disable react/jsx-props-no-spreading */
import { TreeSupplierViewItemType } from '../../types/EquipmentTypes';
import { formatSupplierEquipmentInfo } from './formatEquipmentInfo';
import { Card, CardHeader, Title } from './Tree.styles';
import TreeView from './TreeView';

interface TreeSupplierViewProps {
  structure: TreeSupplierViewItemType[];
}

const TreeSupplierView = ({
  structure,
}: TreeSupplierViewProps): JSX.Element => {
  const showCard = (item) => (
    <Card
      statusColor="black"
      {...((item.standardServices?.length ||
        item.customServices?.length ||
        item.makers?.length) && {
        tooltip: `Standard Services: ${item.standardServices?.join(
          ', '
        )}<br />Custom Services: ${
          item.customServices?.length ? item.customServices?.join(', ') : '-'
        }<br />Makers: ${item.makers?.length ? item.makers?.join(', ') : '-'}`,
      })}
    >
      <CardHeader>
        <Title>
          {item.title}{' '}
          {formatSupplierEquipmentInfo(
            item.standardServices,
            item.customServices,
            item.makers
          )}
        </Title>
      </CardHeader>
    </Card>
  );

  return <TreeView showCard={showCard} structure={structure} />;
};

export default TreeSupplierView;
